export default "__VITE_ASSET__Bq8wYj3f__"